import { render } from "./lypnotice.vue?vue&type=template&id=1d9f46de&scoped=true"
import script from "./lypnotice.vue?vue&type=script&lang=js"
export * from "./lypnotice.vue?vue&type=script&lang=js"

import "./lypnotice.vue?vue&type=style&index=0&id=1d9f46de&scoped=true&lang=css"

import exportComponent from "/Users/h5/Desktop/project/外包/shugutong/yxLink/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d9f46de"]])

export default __exports__